import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

interface TermsAndConditionsProps {
  isOpen: boolean
  onClose: () => void
}

export function TermsAndConditions({ isOpen, onClose }: TermsAndConditionsProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold">
            Terms and Conditions
          </DialogTitle>
          <DialogDescription>
            Last updated: {new Date().toLocaleDateString()}
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-6 text-sm leading-relaxed">
          <section>
            <h3 className="text-lg font-semibold mb-3">1. Acceptance of Terms</h3>
            <p className="mb-3">
              By accessing and using QuickDB ("the Service"), you accept and agree to be bound by the terms and provision of this agreement.
            </p>
            <p>
              If you do not agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">2. Use License</h3>
            <p className="mb-3">
              Permission is granted to temporarily download one copy of the materials (information or software) on QuickDB's website for personal, non-commercial transitory viewing only.
            </p>
            <p className="mb-3">This is the grant of a license, not a transfer of title, and under this license you may not:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>modify or copy the materials</li>
              <li>use the materials for any commercial purpose or for any public display (commercial or non-commercial)</li>
              <li>attempt to decompile or reverse engineer any software contained on QuickDB's website</li>
              <li>remove any copyright or other proprietary notations from the materials</li>
              <li>transfer the materials to another person or "mirror" the materials on any other server</li>
            </ul>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">3. Disclaimer</h3>
            <p className="mb-3">
              The materials on QuickDB's website are provided on an 'as is' basis. QuickDB makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">4. Limitations</h3>
            <p>
              In no event shall QuickDB or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on QuickDB's website, even if QuickDB or a QuickDB authorized representative has been notified orally or in writing of the possibility of such damage.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">5. Accuracy of Materials</h3>
            <p>
              The materials appearing on QuickDB's website could include technical, typographical, or photographic errors. QuickDB does not warrant that any of the materials on its website are accurate, complete or current. QuickDB may make changes to the materials contained on its website at any time without notice.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">6. Links</h3>
            <p>
              QuickDB has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by QuickDB of the site. Use of any such linked website is at the user's own risk.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">7. Modifications</h3>
            <p>
              QuickDB may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these Terms and Conditions of Use.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">8. Governing Law</h3>
            <p>
              These terms and conditions are governed by and construed in accordance with the laws and you irrevocably submit to the exclusive jurisdiction of the courts in that state or location.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">9. Contact Information</h3>
            <p>
              If you have any questions about these Terms and Conditions, please contact us at support@quickdb.com
            </p>
          </section>
        </div>
      </DialogContent>
    </Dialog>
  )
} 